module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0013.3e8608e9.jpg";